<!-- USed to on or off spam mail notification summary
to change the notification timings like to get notification per min, hour, day....
In (UI) System Settings-> Spam Notification
-->
<template>
  <div>
    <v-row no-gutters>
      <v-col sm="8" class="pa-0">
        <h2>Spam Notifications</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row v-if="!initialLoading">
          <v-col>
            <h3>Notification Types</h3>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-4 ml-0" v-if="!initialLoading">
          <span class="mr-4" align-items="center">Spam Summary</span>
          <ToggleButton />
        </v-row>
        <v-row v-else class="mt-4 ml-0">
          <v-col sm="12" class="px-0">
            <v-skeleton-loader
              type="heading"
              :loading="true"
              class="pb-4"
            ></v-skeleton-loader>
            <v-skeleton-loader
              type="paragraph"
              :loading="true"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-if="showData">
      <v-row align="center">
        <v-col>
          <VueCronEditorBuefy
            ref="cron"
            :preserveStateOnSwitchToAdvanced="true"
            v-model="sample1CronExpression"
          ></VueCronEditorBuefy>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col sm="3">
          <span>Quarantine report content control</span>
        </v-col>
        <v-col sm="6">
          <v-select
            :items="reportContent"
            solo
            dense
            flat
            v-model="selectedAction"
            append-icon="keyboard_arrow_down"
            item-value="key"
            class="cursorPointer"
            background-color="#E5E5E5 !important"
            item-text="value"
            height="52px"
          ></v-select>
        </v-col>
      </v-row>
    </div>
    <v-row align="center" v-if="!initialLoading">
      <v-col class="text-right">
        <x-button
          outline
          color="#58e2c2"
          @click="getSpamNotificationData"
          buttonText="Reset"
        />
        <x-button
          color="#58e2c2"
          @click="openConfirmBox"
          buttonText="Save mailbox settings"
          class="w-auto ml-2"
        />
      </v-col>
    </v-row>
    <x-dialog
      :dialogState="confirmDialogueVar"
      :dialogTitle="dialogTitle"
      :dialogText="dialogText"
      :confirmDialog="true"
      @toggleModal="cancelSaveSetting"
      :actions="{
        show: true,
        secondaryButtonFunction: cancelSaveSetting,
        primaryButtonFunction: saveSpamAlert,
        primaryButtonShow: true,
        secondaryButtonText: cancelText,
        primaryButtonText: successText
      }"
    ></x-dialog>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import ToggleButton from '@/components/Common/ToggleButton';
import VueCronEditorBuefy from 'vue-cron-editor-buefy';
import PreferencesService from '@/services/PreferencesService';
import PreferenceHelper from '@/helpers/PreferenceHelper';
export default {
  components: {
    ToggleButton,
    VueCronEditorBuefy
  },
  data() {
    return {
      showData: false,
      sample1CronExpression: '',
      selectedAction: '',
      spamId: '',
      reportContent: [
        { key: 'INCLUDE_ALL_SPAM', value: 'Include all spam' },
        {
          key: 'EXCLUDE_HIGH_SCORING_SPAM',
          value: 'Exclude high scoring spam'
        },
        {
          key: 'EXCLUDE_HIGH_AND_MEDIUM_SCORING_SPAM',
          value: 'Exclude high & medium scoring spam'
        }
      ],
      confirmDialogueVar: false,
      dialogTitle: '',
      dialogText: '',
      cancelText: '',
      successText: '',
      preferenceServiceHelper: null,
      initialLoading: false,
      selectedCronTab: '',
      previousCronValue: ''
    };
  },
  props: ['title'],
  mounted() {
    this.preferenceServiceHelper = new PreferenceHelper();
    EventBus.$on('TOGGLE_VALUE', data => {
      this.showData = data;
    });
    this.getSpamNotificationData();
  },
  methods: {
    // to get the notification data
    async getSpamNotificationData() {
      this.initialLoading = true;
      try {
        let res = await PreferencesService.getPreferencesByPreferenceKey(
          this.$preference.SPAM_NOTIFICATION
        );
        let parsedResponse = this.parseResponse(res);
        if (parsedResponse !== false) {
          this.selectedAction =
            parsedResponse[0].results[0].data.qurantineControl;
          this.sample1CronExpression =
            parsedResponse[0].results[0].data.spamAlert;
          this.previousCronValue = parsedResponse[0].results[0].data.spamAlert;
          this.showData = parsedResponse[0].results[0].data.alertType.summary;
          this.$nextTick(() => {
            EventBus.$emit(
              'TOGGLE_VALUE_SET',
              parsedResponse[0].results[0].data.alertType.summary
            );
            this.setCronValue();
          });
          this.spamId = parsedResponse[0].results[0].id;
        } else {
          this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
        }
        this.initialLoading = false;
      } catch (err) {
        this.snackbar('error', err);
        this.initialLoading = false;
      }
    },
    // to set the current selected tab value(like minutes, hours, daily..) to selecedCronTab
    setCronValue() {
      this.selectedCronTab = this.$refs.cron && this.$refs.cron.currentTab;
      this.$watch(
        () => {
          return this.$refs.cron && this.$refs.cron.currentTab;
        },
        val => {
          if (val === this.selectedCronTab) {
            this.sample1CronExpression = this.previousCronValue;
          }
        }
      );
    },
    // to set the confirm box data to change settings
    openConfirmBox() {
      this.dialogTitle = 'Please Confirm';
      this.dialogText =
        'Are you sure you want to save spam notification settings ?';
      this.cancelText = 'Cancel';
      this.successText = 'Yes';
      this.confirmDialogueVar = true;
    },
    // updating new spam alert settings
    async saveSpamAlert() {
      let reqObject = this.preferenceServiceHelper.createPreferenceBody(
        'spam',
        {
          cron: this.sample1CronExpression,
          quarantine: this.selectedAction,
          alertType: this.showData
        }
      );
      let url = '';
      if (this.spamId === this.preferenceServiceHelper.defaultPreferenceId) {
        url = PreferencesService.addPreference(
          this.$preference.SPAM_NOTIFICATION,
          reqObject
        );
      } else {
        url = PreferencesService.updatePreference(
          this.$preference.SPAM_NOTIFICATION,
          this.spamId,
          reqObject
        );
      }
      try {
        let res = await url;
        let parsedResponse = this.parseResponse(res);
        if (parsedResponse !== false) {
          this.selectedAction = parsedResponse[0].data.qurantineControl;
          this.sample1CronExpression = parsedResponse[0].data.spamAlert;
          this.previousCronValue = parsedResponse[0].data.spamAlert;
          this.showData = parsedResponse[0].data.alertType.summary;
          EventBus.$emit(
            'TOGGLE_VALUE_SET',
            parsedResponse[0].data.alertType.summary
          );
          this.spamId = parsedResponse[0].id;
          this.snackbar('success', this.$message.SAVED_SUCCESS);
        } else {
          this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
        }
        this.confirmDialogueVar = false;
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    // to close confirm dialog without any change
    cancelSaveSetting() {
      this.confirmDialogueVar = false;
    }
  },
  watch: {
    currentlySelectedOrgId: function() {
      this.showData = false;
      this.getSpamNotificationData();
    },
    showData: function(value) {
      if (value) {
        this.$nextTick(() => {
          this.setCronValue();
        });
      }
    }
  }
};
</script>

<style>
.v-skeleton-loader__button {
  width: 100% !important;
  height: 50px;
}
</style>
